export default "__VITE_ASSET__c2168d4c__"